import * as React from 'react';

import { showToast } from '@components/Toast';

import { ReactComponent as SuccessIcon } from '@svg/done.svg';
import './index.less';

export default {
    success: (content: React.ReactChild, duration?: number, callback?: () => void) => {
        const successContent = (
            <>
                <img src={`${process.env.PUBLIC_URL}/success.png`} />
                <span>{content}</span>
            </>
        );
        showToast({
            content: successContent,
            duration: duration,
            callback,
            wrapperClassName: 'interviewer-sign-in__message-wrapper'
        });
    },
    error: (content: React.ReactChild, duration?: number, callback?: () => void) => {
        const successContent = (
            <>
                <img src={`${process.env.PUBLIC_URL}/error.png`} />
                <span>{content}</span>
            </>
        );
        showToast({
            content: successContent,
            duration: duration,
            callback,
            wrapperClassName: 'interviewer-sign-in__message-wrapper'
        });
    }
};
